const styles = (theme) => ({
    container: {
        height: '100%',
        padding: '.5em .5em .5em .5em',
    },
    header: {
        justifyContent: 'space-between',
        minHeight: '0',
        height: 'auto',
    },
    title: {
        fontWeight: '400',
    },
    content: {
        padding: '0em 1em 0em 1em',
    },
    search: {
        marginRight: '8px',
        color: theme.palette.primary.main,
        backgroundColor: '#fff',
        borderRadius: '2em',
    },
    searchField: {
        marginTop: '',
    },
    button: {
        textTransform: 'none',
    },
    searchButton: {
        marginLeft: '5px',
    },
});

export default styles;
